module.exports = __webpack_public_path__ + "fonts/unicredit-italic.296cee75.woff";